<template>
	<div>
		<el-row>
			<el-col :span="24">
				<div class="bread">
					<el-breadcrumb separator-class="el-icon-arrow-right">
						<el-breadcrumb-item v-if="$store.state.main.user.m_qaedas_id==0" :to="{ path: '/main' }">基地管理</el-breadcrumb-item>
						<el-breadcrumb-item v-if="$route.query.Packet" :to="{ path: '/iot/Packet' }">分组管理 ( {{$route.query.name}} )</el-breadcrumb-item>
						<el-breadcrumb-item v-else :to="{ path: '/iot/terminal' }">终端管理 ( {{$route.query.name}} )</el-breadcrumb-item>
						<el-breadcrumb-item v-if="$route.query.Packet" :to="{ path: '/iot/PacketData',query: {id: $route.query.Packet,name: $route.query.name }}">设备信息</el-breadcrumb-item>
						<el-breadcrumb-item v-else :to="{ path: '/iot/sensor',query: {id: (id==null?$store.state.Iot.devicesdata1.id:id),type: $route.query.type,name: $route.query.name }}">设备信息</el-breadcrumb-item>
						<el-breadcrumb-item>历史数据</el-breadcrumb-item>
					</el-breadcrumb>
				</div>
			</el-col>
		</el-row>
		<el-row>
			<el-col :md="5">
				<div class="select">
					<el-checkbox-group v-model="checkList" :size="$store.state.width<$store.state.minwidth?'mini':''">
						<el-checkbox @change="changeline" v-model="checkedline" label="曲线显示"></el-checkbox>
						<el-checkbox @change="changetable" v-model="checkedtable" label="表格显示"></el-checkbox>
					</el-checkbox-group>
				</div>
			</el-col>
			<el-col :md="19">
				<div class="block">
					<el-date-picker class="picker" v-model="value6" type="daterange" range-separator="至" start-placeholder="开始日期"
					 end-placeholder="结束日期" :picker-options="pickerOptions" :size="$store.state.width<$store.state.minwidth?'mini':''">
					</el-date-picker>
					<el-button class="b-find" :size="$store.state.width<$store.state.minwidth?'mini':''" type="primary" icon="el-icon-search"
					 @click="find()">查询</el-button>
					<el-button class="b-dchu" :size="$store.state.width<$store.state.minwidth?'mini':''" @click="exportExcel()" type="primary"
					 icon="el-icon-download">导出</el-button>
				</div>
			</el-col>
		</el-row>
		<el-row class="center">
			<el-col :span="24">
				<div class="center anniu">
					<div class="quxian" id="myChart"></div>
				</div>
			</el-col>
		</el-row>
		<el-row class="center top">
			<el-col :span="24">
				<div class="center anniu" style="height:30vh">
					<el-table class="table" :data="$store.state.Iot.devicesdata1.list" border style="width: 100%" max-height="300"
					 :default-sort="{prop: 'updatetime', order: 'descending'}">
						<el-table-column type="index" label="编号" width="50" header-align="center" align="center"></el-table-column>
						<!-- <el-table-column prop="name" label="名称" width="180"></el-table-column> -->
						<el-table-column prop="content" label="参考值" header-align="center" align="center">
							<template slot-scope="scope">
								<span>{{ $route.query.type==1?scope.row.battery:scope.row.content }} {{$store.state.Iot.device.unit}}</span>
							</template>
						</el-table-column>
						<el-table-column prop="updatetime" label="更新时间" header-align="center" align="center">
							<template slot-scope="scope">
								<span>{{ Totime($route.query.type==1?scope.row.updateTime:scope.row.updatetime) }}</span>
							</template>
						</el-table-column>
					</el-table>
				</div>
			</el-col>
		</el-row>
	</div>
</template>

<script>
	// npm install --save xlsx file-saver
	import FileSaver from 'file-saver'
	import XLSX from 'xlsx'
	export default {
		data() {
			return {
				myload: true,
				data: [],
				checkList: ['表格显示', '曲线显示'],
				value6: [],
				checkedline: false,
				checkedtable: false,
				id: null,
				Content: {
					maxContent: null,
					minContent: null
				},
				pickerOptions: {
					shortcuts: [{
							text: '最近三天',
							onClick(picker) {
								const end = new Date();
								const start = new Date();
								start.setTime(start.getTime() - 3600 * 1000 * 24 * 3);
								picker.$emit('pick', [start, end]);
							}
						},
						{
							text: '最近一周',
							onClick(picker) {
								const end = new Date();
								const start = new Date();
								start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
								picker.$emit('pick', [start, end]);
							}
						},
						{
							text: '最近十天',
							onClick(picker) {
								const end = new Date();
								const start = new Date();
								start.setTime(start.getTime() - 3600 * 1000 * 24 * 10);
								picker.$emit('pick', [start, end]);
							}
						},
						{
							text: '最近一个月',
							onClick(picker) {
								const end = new Date();
								const start = new Date();
								start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
								picker.$emit('pick', [start, end]);
							}
						},
						{
							text: '最近两个月',
							onClick(picker) {
								const end = new Date();
								const start = new Date();
								start.setTime(start.getTime() - 3600 * 1000 * 24 * 30 * 2);
								picker.$emit('pick', [start, end]);
							}
						},
						{
							text: '最近三个月',
							onClick(picker) {
								const end = new Date();
								const start = new Date();
								start.setTime(start.getTime() - 3600 * 1000 * 24 * 30 * 3);
								picker.$emit('pick', [start, end]);
							}
						},
						{
							text: '最近一年',
							onClick(picker) {
								const end = new Date();
								const start = new Date();
								start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
								picker.$emit('pick', [start, end]);
							}
						}
					]
				}
			}
		},
		mounted() {
			this.load();
		},
		methods: {
			drawLine() {
				// 基于准备好的dom，初始化echarts实例
				let myChart = this.$echarts.init(document.getElementById('myChart'));
				var unit = this.$store.state.Iot.device.unit != 0 ? "(" + this.$store.state.Iot.device.unit + ")" : "";
				// 绘制图表
				myChart.setOption({
					title: {
						text: this.$store.state.Iot.device.description
					},
					tooltip: {
						trigger: 'axis',
						formatter: function(params, ticket) {
							var result = params[0].value[0] + " <br/>" + params[0].seriesName + " : " + params[0].value[1];
							return result;
						}
					},
					legend: {
						data: [this.$store.state.Iot.device.alias + unit],
						x: "right"
					},
					grid: {
						left: '2%',
						right: '60px',
						containLabel: true
					},
					xAxis: {
						type: 'time'
					},
					yAxis: {
						max: this.Content.maxContent,
						min: this.Content.minContent,
						type: 'value'
					},
					series: [{
						name: this.$store.state.Iot.device.alias + unit,
						smooth: true,
						type: 'line',
						itemStyle: {
							normal: {
								color: '#a8bcd4'
							}
						},
						data: this.data
					}],
					dataZoom: [{
							type: 'slider',
							xAxisIndex: 0,
							filterMode: 'none'
						},
						{
							type: 'slider',
							yAxisIndex: 0,
							filterMode: 'none'
						},
						{
							type: 'inside',
							xAxisIndex: 0,
							filterMode: 'none'
						},
						{
							type: 'inside',
							yAxisIndex: 0,
							filterMode: 'none'
						}
					]
				});
			},
			exportExcel() {
				/* npm install --save xlsx file-saver 需要获取依赖 */
				var wb = XLSX.utils.table_to_book(document.querySelector('.table'))
				/* get binary string as output */
				var wbout = XLSX.write(wb, {
					bookType: 'xlsx',
					bookSST: true,
					type: 'array'
				})
				try {
					FileSaver.saveAs(new Blob([wbout], {
						type: 'application/octet-stream'
					}), 'sheetjs.xlsx')
				} catch (e) {
					if (typeof console !== 'undefined') console.log(e, wbout)
				}
				this.$message({
					message: '导出成功！',
					type: 'success'
				});
				return wbout
			},
			changeline() {
				if (this.checkedline === true) {
					document.querySelector('#myChart').style.display = "block";
					this.checkedline = false;
				} else {
					document.querySelector('#myChart').style.display = "none";
					this.checkedline = true;
				}
			},
			changetable() {
				if (this.checkedtable === true) {
					document.querySelector('.table').style.display = "block";
					this.checkedtable = false;
				} else {
					document.querySelector('.table').style.display = "none";
					this.checkedtable = true;
				}
			},
			back() {
				this.$router.push({
					path: '/Daohang/Sensor',
					query: {
						id: this.terminalInfo.id
					}
				});
			},
			load() {
				this.id = this.$route.query.zd;
				this.$store.commit('mainload', true);
				this.value6.push(new Date(new Date().getTime() - 60 * 60 * 24 * 7 * 1000));
				this.value6.push(new Date());
				let value = {};
				if (this.$route.query.type == 1) {
					value = {
						devicesId: this.$route.query.id,
						startTime: new Date().getTime() / 1000 - 60 * 60 * 24 * 7,
						endTime: new Date().getTime() / 1000,
						order: "updatetime asc"
					};
				} else {
					value = {
						devices_id: this.$route.query.id,
						start_time: new Date().getTime() / 1000 - 60 * 60 * 24 * 7,
						end_time: new Date().getTime() / 1000,
						order: "updatetime asc"
					};
				}
				this.getdevicesdata1(value, this.$route.query.type)
					.then((response) => {
						if (response.data.code == 1) {
							if (this.$route.query.type == 1) {
								for (var i = 0; i < this.$store.state.Iot.devicesdata1.list.length; i++) {
									this.data.push([
										this.Totime(this.$store.state.Iot.devicesdata1.list[i].createTime),
										this.$store.state.Iot.devicesdata1.list[i].battery
									])
								}
							} else {
								this.Content.minContent = Number(response.data.data.minContent);
								this.Content.maxContent = Number(response.data.data.maxContent);
								for (var i = 0; i < this.$store.state.Iot.devicesdata1.list.length; i++) {
									this.data.push([
										this.Totime(this.$store.state.Iot.devicesdata1.list[i].createtime),
										this.$store.state.Iot.devicesdata1.list[i].content
									])
								}
							}
							this.getsonser();
							this.$store.commit('mainload', false);
						}
					});
			},
			find() {
				if (this.value6 == null) {
					return;
				}
				let value = {};
				if (this.$route.query.type == 1) {
					value = {
						devicesId: this.$route.query.id,
						startTime: this.value6[0].getTime() / 1000,
						endTime: this.value6[1].getTime() / 1000 + 60 * 60 * 24,
						order: "updatetime asc"
					};
				} else {
					value = {
						devices_id: this.$route.query.id,
						start_time: this.value6[0].getTime() / 1000,
						end_time: this.value6[1].getTime() / 1000 + 60 * 60 * 24,
						order: "updatetime asc"
					};
				}
				this.$store.commit('mainload', true);
				this.getdevicesdata1(value, this.$route.query.type)
					.then((response) => {
						this.$store.commit('mainload', false);
						if (response.data.code == 1) {
							this.data = [];
							if (!this.$route.query.type == 1) {
								this.Content.minContent = Number(response.data.data.minContent);
								this.Content.maxContent = Number(response.data.data.maxContent);
							}
							for (var i = 0; i < this.$store.state.Iot.devicesdata1.list.length; i++) {
								if (this.$route.query.type == 1) {
									this.data.push([
										this.Totime(this.$store.state.Iot.devicesdata1.list[i].createTime),
										this.$store.state.Iot.devicesdata1.list[i].battery
									])
								} else {
									this.data.push([
										this.Totime(this.$store.state.Iot.devicesdata1.list[i].createtime),
										this.$store.state.Iot.devicesdata1.list[i].content
									])
								}
							}
							this.drawLine();
						}
					});
			},
			getsonser() {
				let value = {
					id: this.$route.query.id
				};
				this.getdevice(value)
					.then((response) => {
						if (response.data.code == 1) {
							this.drawLine();
						}
					});
			}
		}
	}
</script>

<style scoped>
	.quxian {
		background: white;
		margin-top: 10px;
		height: 700px;
	}

	.xianshi {
		margin-top: 0px;
		height: 10vh;
	}

	.top1 {
		margin-top: 10px;
		text-align: right;
		font-size: 20px
	}

	.center {
		text-align: center;
		margin: auto;
	}

	.top {
		margin-top: 10px;
	}

	.bread {
		height: 14px;
		padding: 8px 0;
	}

	.select {
		line-height: 40px;
	}

	.b-dchu {
		float: right;
	}

	@media screen and (min-width: 0px) and (max-width: 700px) {
		.bread {
			padding-left: 5px;
		}

		.anniu {
			margin: 0 5px;
		}

		.select {
			line-height: 25px;
			padding-left: 5px;
		}

		.block {
			padding-left: 5px;
			padding-right: 5px;
		}

		.b-find {
			margin-top: 10px;
		}

		.b-dchu {
			margin-top: 10px;
		}

		.picker {
			width: 100% !important;
		}

		.quxian {
			height: 400px;
		}
	}
</style>
